export default __webpack_public_path__ + "static/media/dashboard-survey.7b30f168.svg";